import initializeFirebase from 'packages/firebase/init';
import { getPerformance } from 'firebase/performance';

function loadPerfMon() {
  initializeFirebase();
  return getPerformance();
}

export default loadPerfMon;
